# Right now, setting this is global
# Once all js is brunched, we'll require it in the relevant files instead
PT.Utils.Template = (name, data = false) ->
  template = require("#{name}.html.hbs")
  return if data then template(data) else template